import EmployeeWorkInWorkInComponents from "../components/EmployeeWorkInWorkIn";
import useEmployeeWorkInWorkIn from "../hooks/useEmployeeWorkInWorkIn";

function EmployeeWorkInWorkIn() {
  const employeeWorkInWorkInProps = useEmployeeWorkInWorkIn();
  return <EmployeeWorkInWorkInComponents {...employeeWorkInWorkInProps} />;
}

export default EmployeeWorkInWorkIn;
